import { render, staticRenderFns } from "./disputes-table-overview-stats-breakdown-card.vue?vue&type=template&id=55376d40"
import script from "./disputes-table-overview-stats-breakdown-card.vue?vue&type=script&lang=js"
export * from "./disputes-table-overview-stats-breakdown-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports